import { render } from "./admin-auth-layout.vue?vue&type=template&id=555be65c"
import script from "./admin-auth-layout.vue?vue&type=script&lang=js"
export * from "./admin-auth-layout.vue?vue&type=script&lang=js"

import "./admin-auth-layout.vue?vue&type=style&index=0&id=555be65c&lang=scss"

import exportComponent from "D:\\SVNwork\\01_工程区\\01_代码\\RPAPortal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__